import React from "react";
import FullScreenMessage from "../../Reusable/FullScreenMessage/FullScreenMessage.js";
import { useParams } from "react-router-dom";

import "./Error.scss";

const Error = ({ customType }) => {
  const { type } = useParams();
  const errType = customType || type;
  const title = !errType
    ? "page-not-found-title"
    : `${errType?.toLowerCase()}-title`;
  const message = !errType
    ? "page-not-found-content"
    : `${errType.toLowerCase()}-message`;

  const returnEnum = {
    "unsupported-browser": {
      component: "NotSupportedBrowserMessage",
      image: { src: "robot", ext: "png" },
      containerCenter: true,
    },
    "uploading-error": {
      component: "UploadingError",
      image: { src: "paper-plane-crushed-circled", ext: "svg" },
      containerCenter: true,
    },
  };
  const dataToSHow = {
    title: title,
    content: message,
    image: { src: "paper-plane-crushed-circled", ext: "svg" },
    containerCenter: true,
  };

  return (
    <FullScreenMessage
      message={{
        isShow: true,
        data: returnEnum[errType] || dataToSHow,
      }}
      isShowOnStart={true}
    ></FullScreenMessage>
  );
};
export default Error;
